import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import classNames from 'classnames';
import 'styles/utils/form/ClickToEditField.styl';

export default class ClickToEditField extends React.PureComponent {
  isSaveDisabled() {
    const hasErrors = !!this.props.errors && this.props.errors[this.props.field];
    return hasErrors || this.props.isSaving;
  }

  onSave = () => {
    const {field, model, stagingModel} = this.props;
    this.props.onSave(field, model.set(field, stagingModel[field]));
  };

  // TODO: a must be replaced with button and eslint ignore must be removed
  /* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
  render() {
    const {field, className} = this.props;
    return (
      <div
        className={classNames('click-to-edit-field', className, {
          'edit-toggled': this.props.toggledFields[field],
        })}>
        {this.props.toggledFields[field] ? (
          <div className="edit-area">
            {this.props.children}
            <RaisedButton
              onClick={this.onSave}
              primary={true}
              label="Save"
              disabled={this.isSaveDisabled()}
              className="ev-button"
            />
            <RaisedButton
              onClick={() => this.props.onCancel(field)}
              label="Cancel"
              disabled={this.props.isSaving}
              className="ev-button"
            />
          </div>
        ) : (
          <div className="static-area">
            <a href="javascript:" onClick={() => this.props.onToggleEdit(field)}>
              {this.props.readOnlyContent === undefined
                ? this.props.model[field]
                : this.props.readOnlyContent}
            </a>
          </div>
        )}
      </div>
    );
  }
}
